import { StyleSheet, View, ScrollView, TouchableOpacity } from "react-native";
import Button from "../Button";
import React, { useState } from "react";
import color from "@constants/color";
import CustomText from "../CustomText";
import Cross from "@assets/svg/Cross";
import t from "@constants/localization";
import RadioButton from "@components/RadioButton";

const PATH = "components/InAppRTOModal";

const RTOFeedbackModal = ({
  hideFeedbackModal = () => {},
  meta = {},
  submitFeedback = () => {},
  action = {},
}) => {
  const modalData = meta[`${action.reasons}`];
  const [currentFilter, setCurrentFilter] = useState({});
  const setSelectedOption = (key) => {
    if (currentFilter === key) return;
    setCurrentFilter(key);
  };
  return (
    <View style={styles.modalContainer}>
      <ScrollView
        style={styles.scrollView}
        contentContainerStyle={styles.contentContainerStyle}
      >
        <View style={styles.viewContainer}>
          <View style={styles.titleContainer}>
            <CustomText
              variant="entityHeading"
              newfont={true}
              style={styles.title}
              numberOfLines={3}
            >
              {modalData?.title}
            </CustomText>
            <TouchableOpacity
              style={styles.crossButton}
              onPress={hideFeedbackModal}
            >
              <Cross width={12} height={12} />
            </TouchableOpacity>
          </View>
          <View style={styles.lineStyle} />
          <RadioButton
            radioOptions={modalData?.list}
            setSelectedOption={setSelectedOption}
            labelColor={color.mediumBlack}
            radioColor={color.primary}
            active={currentFilter.key}
          />
          <Button
            disabled={Object.keys(currentFilter).length === 0}
            btnText={t(`${PATH}/submit`)}
            buttonWidth="100%"
            borderRadius={8}
            buttonFontType="content1"
            onPress={() => submitFeedback(currentFilter)}
            containerStyle={styles.buttonContainer}
          />
        </View>
      </ScrollView>
    </View>
  );
};

export default RTOFeedbackModal;

const styles = StyleSheet.create({
  contentContainerStyle: {
    flexDirection: "column",
    justifyContent: "flex-end",
    flexGrow: 1,
  },
  scrollView: {
    maxHeight: "80%",
  },
  modalContainer: {
    backgroundColor: color.modalBackground,
    flexDirection: "column",
    justifyContent: "flex-end",
    flex: 1,
  },
  viewContainer: {
    backgroundColor: color.white,
    paddingTop: 24,
    paddingBottom: 20,
    borderTopEndRadius: 20,
    borderTopStartRadius: 20,
  },
  titleContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 16,
  },
  title: {
    marginBottom: 0,
    paddingHorizontal: 0,
    color: color.mediumBlack,
  },
  crossButton: {
    width: 30,
    height: 30,
    borderRadius: 15,
    backgroundColor: color.shadowLighter,
    justifyContent: "center",
    alignItems: "center",
  },
  lineStyle: {
    height: 1,
    backgroundColor: color.blank_grey,
    marginTop: 12,
  },
  buttonContainer: {
    marginTop: 20,
    marginHorizontal: 16,
  },
});
